import { createBrowserRouter, Navigate } from 'react-router';
import { RootErrorPage, NotFoundPage, NoTenantPage } from '@/pages/SystemPages';
import { TenantLayout } from '@/features/tenant/TenantLayout';
import { ClientLayout } from '@/pages/client/ClientLayout';
import { HomePage } from '@/pages/client/HomePage';
import { ServicesPage } from '@/pages/client/ServicesPage';
import { BookingDetailsPage } from '@/pages/client/BookingDetailsPage';
import { MyBookingsPage } from '@/pages/client/MyBookingsPage';

/** The owner cabinet loads on demand so clients never download it. */
const owner = (name: keyof typeof import('@/pages/owner')) => async () => ({ Component: (await import('@/pages/owner'))[name] });

export const router = createBrowserRouter([
  { path: '/', element: <NoTenantPage />, errorElement: <RootErrorPage /> },
  {
    path: '/s/:slug',
    element: <TenantLayout />,
    errorElement: <RootErrorPage />,
    children: [
      {
        element: <ClientLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'services', element: <ServicesPage /> },
          { path: 'booking', lazy: async () => ({ Component: (await import('@/pages/client/BookingFlowPage')).BookingFlowPage }) },
          { path: 'booking/:token', element: <BookingDetailsPage /> },
          { path: 'my', element: <MyBookingsPage /> },
        ],
      },
      { path: 'owner/login', lazy: owner('OwnerLoginPage') },
      {
        path: 'owner',
        lazy: owner('OwnerLayout'),
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: 'dashboard', lazy: owner('OwnerDashboardPage') },
          { path: 'bookings', lazy: owner('OwnerBookingsPage') },
          { path: 'bookings/new', lazy: owner('OwnerNewBookingPage') },
          { path: 'services', lazy: owner('OwnerServicesPage') },
          { path: 'settings', lazy: owner('OwnerSettingsPage') },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
